import React from "react";

const TabCard = ({title, blurb, imgSrc, path, numCards, index}) => {

  return (
    <div className={"small-12 columns tab-card large-4 medium-4 end "  + (index === 0 && numCards === 2 ? "large-offset-2 medium-offset-2" : "")} data-equalizer-watch="tab-cards" onClick={() => window.location.href = path}>
      <img src={imgSrc}/>
      <h4>{title}</h4>
      <p>{blurb}</p>
      <a className="button stencil-blue grey-border">Read More</a>
    </div>
  )
}

export default TabCard;